import http from './axios';
// import {StringFormat} from '@/libs/util'

export interface DatacollectDto {
  id?: number;
  // 数据采集表目录
  collectCategoryId?: number;
  collectCategoryName?: string;
  // 采集任务名称
  collectJobName?: string;
  // flinkx运行 job name
  //jobFlinkName?: string;
  // 采集任务编码
  collectJobCode?: string;
  // 采集任务类型 0-离线 1-实时
  collectJobType?: number;
  collectJobTag?: string;
  // 采集任务描述
  collectJobDesc?: string;
  // 所属加工流程
  taskFlowId?: number;
  taskFlowName?: string;
  // 所属加工流程节点ID
  taskNodeId?: string;
  // 父加工任务
  parentJobCode?: string;
  // 源数据源类型
  sourceDsType?: string;
  // 源数据源ID
  sourceDsId?: number;
  // 源数据源名称
  sourceDsName?: string;
  // 源数据对象ID
  sourceDsTableId?: number;
  // 名称
  sourceDsTableName?: string;
  // 源数据字段定义
  sourceDsColumns?: Array<DsColumnCfg>;
  // 目标数据源ID
  sinkDsId?: number;
  // 目标数据源类型
  sinkDsType?: string;
  // 目标数据源名称
  sinkDsName?: string; 
  // 目标数据字段定义
  sinkDsColumns?: Array<DsColumnCfg>;
  // 目标数据对象ID 
  sinkDsTableId?: number; 
  // 目标数据对象名称
  sinkDsTableName?: string;
  // 同步配置信息
  syncConfig?: Array<SyncColumnsInfo>;
  // 作业运行配置（批处理）
  batchJobInfo?: BatchJobInfo;
  // 通道配置（流处理）
  tunnelInfo?: StreamTunnelInfo;
  // 使用状态，0-启用，1-禁用
  status?: number;
  // 是否是模板
  templateFlag?: number;
  // 审批状态
  //approveStatus?: number;
  //项目
  //projectId?: number;

   // 增量字段名称
   //incrementColumn?: string;
   // 增量字段类型
   //incrementColumnType?: string;
   // restore字段名称
   //restoreColumn?: string;
   // restore字段类型
   //restoreColumnType?: string;
   // 切分字段名称
   //partitionColumn?: string;
   // 增量字段开始位置,如果不指定则先同步所有，然后在增量
   //startLocation?: string;
}

export interface DsColumnCfg {
  id?: number;
  tableId?: number;
  pkFlag?: number;
  partitionFlag?: number;
  incrementFlag?: number;
  columnNameEn?: string;
  columnNameCn?: string;
  columnLogicName?: string;
  dataTypeEn?: string;
  dataTypeCn?: string;
  status?: number;
}

export interface SyncColumnsInfo {
  sort?: number;
  sourceTable?: string;
  sourceColumnId?: number;
  sourceColumnNameEn?: string;
  sourceColumnNameCn?: string;
  sinkTable?: string;
  sinkColumnId?: number;
  sinkColumnNameEn?: string;
  sinkColumnNameCn?: string;
}

export interface BatchJobInfo {
  // 采集方式 0-增量,1-全量
  jobMode?: number;
  // 增量方式
  incrementType?: number;
  // 增量查询起始位置
  startLocation?: string;
  // 清理方式 0-写入前保留,1-写入前清理
  cleanMode?: number;
  // 调度方式  0-手动,1-定时,2-周期
  triggerMode?: number;
  // 频率 0-秒；1-分；2-小时；3-日；4-月；5-年
  rate?: number;
  runDateStr?: string;
  runTimeStr?: string;
  day?: number;
  weekday?: string;
  season?: number;
  failRetryCount?: number;
  failTimeout?: number;
  // cron表达式
  cronExpression?: string;
  // 数据时效 0->T,1->T-1,2->T-2
  dataDuration?: number;
  // 并行度
  parallelism?: number;
}

export interface StreamTunnelInfo {
  // 开启间隔轮询
  pollingInterval?: number;
  // 增量方式
  incrementType?: number;
  startLocation?: string;
  // kafka消费的启动模式，有效值为'earliest-offset'，'latest-offset'，'group-offsets'，'timestamp'和'specific-offsets'。
  startupMode?: string;
  // 从'timestamp'启动模式下使用的指定纪元时间戳（毫秒）开始
  startupTimestamp?: number;
  startupOffset?: string;
  // 并行度
  parallelism?: number;
}

export default class DatacollectServices {
  private readonly category_api = '/v1/data/collects/category';
  private readonly list_api = '/v1/data/collects/list';
  private readonly info_api = '/v1/data/collects/info';
  private readonly save_api = '/v1/data/collects/save';
  private readonly update_api = '/v1/data/collects/update';
  private readonly updateByCode_api = '/v1/data/collects/updateByCode';
  private readonly remove_api = '/v1/data/collects/delete';
  private readonly clone_api = '/v1/data/collects/clone';

  constructor() {}

  /** 目录 */
  async getCategory(params?: object): Promise<any> {
    let res: any = await http.get(this.category_api, { params: params });
    return res.payload;
  }
  /**  主表单数据 */
  async getList(params?: object): Promise<any> {
    let res: any = await http.get(this.list_api, { params: params });
    return res.payload;
  }

  async getInfo(id: string | number) {
    let res: any = await http.get(this.info_api + '/' + id);
    let formData = this.transformData(res.payload);
    return formData;
  }

  async getInfoByNode(taskFlowId: string | number, taskNodeId: string) {
    let res: any = await http.get(this.info_api + '/' + taskFlowId + '/' + taskNodeId);
    return res.payload;
  }

  async add(data: DatacollectDto) {
    let submitData = this.formatFormData(data);
    const params = { ...submitData, collectJobCode: 'DC_' + data.collectJobCode };
    let res: any = await http.post(this.save_api, params);
    return res.header?.code == 200 ? res.payload : false;
  }

  async update(data: DatacollectDto): Promise<boolean> {
    let res: any = await http.post(this.update_api, this.formatFormData(data));
    return res.header?.code == 200;
  }

  async updateByCode(data: DatacollectDto): Promise<boolean> {
    let res: any = await http.post(this.updateByCode_api, this.formatFormData(data));
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api, [id]);
    return res.header?.code == 200;
  }

  async clone(id: string | number) {
    let res: any = await http.get(this.clone_api + '/' + id);
    return res.header?.code == 200;
  }
  
  //提交数据格式化
  formatFormData(formData: DatacollectDto) {
    let submitData = { ...formData };
    // TODO
    return submitData;
  }
  //显示数据格式化
  transformData(formData: DatacollectDto) {
    let res = '';
    // TODO
    return formData;
  }
  
}
